import { useMutationWithErrorHandling, usePost } from '@app/sdk';

export function useGenerateStatementFile() {
  const post = usePost(true, 'cus');

  function generateStatementFile(cycleDate: string) {
    return post(`/api/proxy/cus/customer-output-service/submissions?cycleDate=${cycleDate}`, {});
  }

  return useMutationWithErrorHandling({
    mutationFn: async (cycleDate: string) => await generateStatementFile(cycleDate),
  });
}